<template>
  <v-dialog v-model="viewItemsModal" max-width="860" scrollable>
    <template v-slot:activator="{ on }">
      <mf-button :label="buttonText" v-on:click.native="on.click" />
    </template>

    <v-card class="table-card my-2">
      <v-card-title>
        <span class="table-card-title">{{ tableTitle }}</span>
        <v-spacer></v-spacer>
        <mf-search v-if="!disableSearch" v-model="search" hide-details :placeholder="searchPlaceholder" />
      </v-card-title>

      <v-card-text>
        <v-data-table :headers="headers" :items="items" :search="search"></v-data-table>

        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: () => (viewItemsModal = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    tableTitle: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default: 'Procure na tabela',
    },
  },

  data: () => ({
    viewItemsModal: false,
    search: '',
  }),

  methods: {
    closeModal() {
      this.viewItemsModal = !this.viewItemsModal
    },
  },
}
</script>

<style lang="scss">
.table-card {
  &-title {
    font-weight: 700;
    font-size: 18px;
    color: $cinza-d20;
  }

  .v-data-table-data {
    padding: 0 10px !important;
  }

  .v-data-table-header {
    font-size: 14px;
    color: $cinza-d10 !important;
  }
}
</style>
